import { useState } from "react";
import { toast } from "sonner";
import { FileText, X, Loader2, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApi, errMsg } from "@/lib/api";

export const AttachmentUploader = ({ items, setItems }) => {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, 10 - items.length);
    e.target.value = "";
    setBusy(true);
    const added = [];
    try {
      for (const file of files) {
        const fd = new FormData();
        fd.append("file", file);
        added.push(await api("post", "/uploads/attachment", fd));
      }
    } catch (err) { toast.error(errMsg(err)); } finally { setItems([...items, ...added]); setBusy(false); }
  };
  return (
    <div className="space-y-2" data-testid="attachment-uploader">
      {items.map((a, i) => (
        <div key={a.path} className="flex items-center gap-3 p-3 rounded-xl border border-slate-200" data-testid={`attachment-item-${i}`}>
          <FileText size={18} className="text-rose-600 shrink-0" />
          <span className="text-sm truncate flex-1">{a.name}</span>
          <button type="button" data-testid={`attachment-remove-${i}`} onClick={() => setItems(items.filter((x) => x.path !== a.path))}><X size={16} /></button>
        </div>
      ))}
      {items.length < 10 && (
        <label className="flex items-center justify-center gap-2 p-4 rounded-xl border-2 border-dashed border-slate-300 hover:border-blue-500 cursor-pointer text-sm text-slate-500">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <FileText size={16} />} Aggiungi PDF (max 25MB)
          <input data-testid="attachment-upload-input" type="file" accept="application/pdf" multiple className="hidden" onChange={upload} disabled={busy} />
        </label>
      )}
    </div>
  );
};

export const AttachmentList = ({ listingId, items }) => {
  const api = useApi();
  const [busy, setBusy] = useState(null);
  const download = async (i, name) => {
    setBusy(i);
    try {
      const blob = await api("get", `/listings/${listingId}/attachments/${i}`, null, { responseType: "blob" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = name; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  if (!items?.length) return null;
  return (
    <div className="mt-8" data-testid="detail-attachments">
      <h2 className="font-heading text-xl font-semibold">Documenti scaricabili</h2>
      <div className="mt-3 space-y-2">
        {items.map((a, i) => (
          <div key={a.path} className="flex items-center gap-3 p-3 rounded-xl bg-white border border-slate-200">
            <FileText size={18} className="text-rose-600 shrink-0" />
            <span className="text-sm truncate flex-1">{a.name}</span>
            <Button size="sm" variant="outline" disabled={busy === i} onClick={() => download(i, a.name)} data-testid={`attachment-download-${i}`}>
              {busy === i ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} className="mr-1" />}Scarica
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};
